import React, { useRef } from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import useMergedState from 'rc-util/es/hooks/useMergedState';
import type { InputRef } from 'antd';
import { AutoComplete, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { AutoCompleteProps } from 'antd/es/auto-complete';

import styles from './index.less';

export type MenuSearchProps = {
  onSearch?: (value?: string) => void;
  onChange?: (value?: string) => void;
  onSelect?: (value: string, option: any) => void;
  onVisibleChange?: (b: boolean) => void;
  className?: string;
  placeholder?: string;
  options: AutoCompleteProps['options'];
  defaultVisible?: boolean;
  visible?: boolean;
  defaultValue?: string;
  value?: string;
  fontSize?: number | string;
};

const MenuSearch: React.FC<MenuSearchProps> = (props) => {
  const {
    className,
    defaultValue,
    onVisibleChange,
    placeholder,
    visible,
    defaultVisible,
    ...restProps
  } = props;
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.RightContent.MenuSearch', intl.formatMessage);

  const inputRef = useRef<InputRef | null>(null);

  const [value, setValue] = useMergedState<string | undefined>(defaultValue, {
    value: props.value,
    onChange: props.onChange,
  });

  const [searchMode, setSearchMode] = useMergedState(defaultVisible ?? false, {
    value: props.visible,
    onChange: onVisibleChange,
  });

  const inputClass = classNames(styles.input, {
    [styles.show]: searchMode,
  });
  return (
    <div
      className={classNames(className, styles.menuSearch)}
      onClick={() => {
        setSearchMode(true);
        if (searchMode && inputRef.current) {
          inputRef.current.focus();
        }
      }}
      onTransitionEnd={({ propertyName }) => {
        if (propertyName === 'width' && !searchMode) {
          if (onVisibleChange) {
            onVisibleChange(searchMode);
          }
        }
      }}
    >
      <SearchOutlined
        key="Icon"
        style={{
          fontSize: restProps?.fontSize,
          cursor: 'pointer',
        }}
      />
      <AutoComplete
        key="AutoComplete"
        className={inputClass}
        value={value}
        options={restProps.options}
        onChange={(value) => {
          setValue(value)
        }}
        onSelect={restProps?.onSelect}
      >
        <Input
          size="small"
          ref={inputRef}
          defaultValue={defaultValue}
          aria-label={placeholder}
          placeholder={placeholder || t('t0', '站内搜索')}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if (restProps.onSearch) {
                restProps.onSearch(value);
              }
            }
          }}
          onBlur={() => {
            setSearchMode(false);
          }}
        />
      </AutoComplete>
    </div>
  );
};

export default MenuSearch;
